import { inject, Injectable, signal } from '@angular/core';
import { BehaviorSubject, Observable, Subject } from 'rxjs';
import { HttpService } from '@services/http.service';
import { environment } from '@environments/environment';
import { UserInfo } from '@models/UserInfo';
import { saveAs } from 'file-saver';
import * as Papa from 'papaparse';
import { ExportTableData } from '@models/CrossReference';
import { ExcelValidationResult } from '@models/ExcelValidationResult';
import { BulkSearchModel } from '@models/BulkSearch';
import { DisplayColumnFields } from '@models/ColumnsModel';
import { ParsedAddress } from '@models/ParsedAddress';

@Injectable({
  providedIn: 'root',
})
export class CommonService {
  selectedResultProfileRcmId: string = '';

  savedGoldenProfiles: any[] = [];

  savedSourceCrossReferences: any[] = [];

  savedSearchParams: any[] = [];
  navFrom = '';
  private _tableDataValues: any[] = [];
  spSubject = new BehaviorSubject<any>(null);
  readonly validateExcelSubject = new Subject<ExcelValidationResult>();
  readonly bsBackButton = new BehaviorSubject<string>('');
  readonly sessionModal = new BehaviorSubject<boolean>(false);
  private intervalId: ReturnType<typeof setInterval> | null = null;
  private readonly _showLoader = signal(false);
  readonly searchFlag = signal(true);
  selectedAffiliationProfile: any = null;
  readonly bulkSearchResponse = signal<BulkSearchModel[]>([]);
  readonly showLoader = this._showLoader.asReadonly();
  readonly fieldsDisplay: DisplayColumnFields[] = [
    { id: 'rcm_id', display: 'RCM ID' },
    { id: 'ishift', display: 'iShift' },
    { id: 'rmus', display: 'RMUS' },
    { id: 'crm', display: 'CRM' },

    { id: 'name', display: 'Name' },
    { id: 'address', display: 'Address' },
    { id: 'dea', display: 'DEA' },
    { id: 'hin_no', display: 'HIN' },
    { id: 'id_340b', display: '340B' },
    { id: 'npi', display: 'NPI' },
    { id: 'sln', display: 'SLN' },
    { id: 'city', display: 'City' },
    { id: 'state', display: 'State' },
    { id: 'zip', display: 'Zip' },
    { id: 'type', display: 'Type' },
    { id: 'source', display: 'Source' },
    { id: 'source_id', display: 'Source ID' },
    { id: 'hcce', display: 'HCCE' },
    { id: 'tddd', display: 'tddd' },
  ];

  private readonly httpService = inject(HttpService);

  setShowLoader(show: boolean): void {
    this._showLoader.set(show);
  }

  getProfileName(url: string): Observable<UserInfo> {
    return this.httpService.get(url);
  }

  startCheckSession(): void {
    // this.intervalId = setInterval(() => {
    //   this.checkSession();
    // }, 5000);
  }

  checkSession(): void {
    let expires_at_str = localStorage.getItem('expires_at');
    if (!expires_at_str) {
      const new_expires_at = new Date();
      new_expires_at.setMinutes(new_expires_at.getMinutes() + 120);
      localStorage.setItem('expires_at', new_expires_at.toString());
      expires_at_str = new_expires_at.toString();
    }
    const expires_at = new Date(expires_at_str);
    const current_time = new Date();
    if (current_time > expires_at) {
      if (this.intervalId) {
        clearInterval(this.intervalId);
        this.intervalId = null;
      }
      this.sessionModal.next(true);
    }
  }

  clearSession(): void {
    localStorage.removeItem('expires_at');
  }

  logOut(): void {
    window.location.href = environment.authLogoutUrl;
  }

  exportToCsv(
    data: ExportTableData[],
    filename: string,
    headers: string[],
    keys?: string[],
  ): void {
    const csvData = data.map((row) => {
      if (keys && keys.length) {
        return keys.map((key) => (row as any)[key] ?? '');
      }
      return Object.values(row);
    });

    const csv = Papa.unparse({
      fields: headers,
      data: csvData,
    });

    const blob = new Blob([csv], { type: 'text/csv;charset=utf-8' });
    saveAs(blob, `${filename}.csv`);
  }

  //"4327 N Ash St Apt B115, Spokane, WA 99205"; address should be in this format
  parseUSAddress(address: string): ParsedAddress | null {
    const regex = /^(.*?),\s*([A-Za-z\s]+),\s*([A-Z]{2})\s*(\d{5})(?:-\d{4})?$/;
    const match = address.trim().match(regex);

    if (!match) return null;

    const [, street, city, state, zip] = match;

    return {
      street: street.trim(),
      city: city.trim(),
      state: state.trim(),
      zip: zip.trim(),
    };
  }
}
